import React from "react";

const CustomCoinCard = ({ img, price, qty, name, click, isGold, purity }) => {
  return (
    <div className="row" onClick={click}>
      <div className="col-12 text-center">
        <img
          src={img}
          className="img-fluid"
          alt="coin"
          style={{ width: "120px" }}
        />
      </div>
      <div
        className="col-12"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: "0.5rem",
          marginTop: "10px",
          marginBottom: "2rem",
        }}
      >
        <h6 className="h6">
          {isGold ? "Gold" : "Silver"} Coin | {qty} Gms | {purity} Purity
        </h6>
        {/* <h6 className="h6">{name}</h6> */}
        {/* <div style={{ fontSize: "14px", marginBottom: "1rem" }}>
          Delivery & making charges: ₹{price}
        </div> */}
        {/* <p className="h6 mb-2">₹{price}</p> */}
      </div>
    </div>
  );
};

export default CustomCoinCard;
